import { render, staticRenderFns } from "./active-gateways-actions-column.vue?vue&type=template&id=485c43a9&"
import script from "./active-gateways-actions-column.vue?vue&type=script&lang=js&"
export * from "./active-gateways-actions-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports